import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "whitespace-nowrap" }

import SvgLoader from "~/vue/atoms/svgs/SvgLoader.vue";
import BadgeCounter from "~/vue/atoms/badges/BadgeCounter.vue";

interface Props {
	label: string;
	loading: boolean;
	selected?: number;
	utilities?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ButtonFilterLocations',
  props: {
    label: {},
    loading: { type: Boolean },
    selected: { default: 0 },
    utilities: { default: "" }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass([
			'relative inline-flex items-center gap-2 rounded-full border-2 border-viridian-500',
			'bg-white px-4 py-2 font-primary text-sm font-medium text-viridian-500',
			'focus:outline-none focus:ring-4 focus:ring-celestial-500',
			'hover:bg-viridian-500 hover:text-white',
			'print:hidden',
			__props.utilities,
		]),
    type: "button"
  }, [
    _createElementVNode("span", {
      class: _normalizeClass([__props.loading ? 'opacity-0' : 'opacity-100'])
    }, [...(_cache[0] || (_cache[0] = [
      _createElementVNode("i", {
        class: "fa-solid fa-sliders",
        "aria-hidden": "true"
      }, null, -1)
    ]))], 2),
    _createElementVNode("span", _hoisted_1, _toDisplayString(__props.label), 1),
    (__props.selected > 0)
      ? (_openBlock(), _createBlock(BadgeCounter, {
          key: 0,
          label: __props.selected
        }, null, 8, ["label"]))
      : _createCommentVNode("", true),
    _createElementVNode("span", {
      class: _normalizeClass([
				__props.loading ? 'opacity-100' : 'opacity-0',
				'absolute right-3 top-1/2 -translate-y-1/2 text-viridian-500',
			])
    }, [
      _createVNode(SvgLoader)
    ], 2)
  ], 2))
}
}

})